module.exports = __webpack_public_path__ + "static/media/empyList.91c8d3c2.png";